// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"7b7bb3e5","160":"47f8d75a","208":"e4811bd8","293":"cef006f9","453":"68472b6a","516":"f0301d49","519":"2fb9be0e","906":"3a1caa14","917":"48d33502","946":"c1c3bfb3"}[chunkId] + ".chunk.js";
};